const BASE = import.meta.env.VITE_API_BASE_URL || "/api/v1";

export class ApiError extends Error {
  status: number;
  body: any;
  constructor(message: string, status: number, body: any) {
    super(message);
    this.status = status;
    this.body = body;
  }
}

function token(): string | null {
  return localStorage.getItem("rpis_token");
}

export function setToken(t: string | null) {
  if (t) localStorage.setItem("rpis_token", t);
  else localStorage.removeItem("rpis_token");
}

async function request<T = any>(
  method: string,
  path: string,
  opts: { body?: any; form?: FormData; raw?: boolean } = {}
): Promise<T> {
  const headers: Record<string, string> = {};
  let body: any = undefined;
  if (opts.form) {
    body = opts.form;
  } else if (opts.body !== undefined) {
    headers["Content-Type"] = "application/json";
    body = JSON.stringify(opts.body);
  }
  const t = token();
  if (t) headers["Authorization"] = `Bearer ${t}`;

  const url = path.startsWith("http")
    ? path
    : path.startsWith("/")
    ? `${BASE}${path}`
    : `${BASE}/${path}`;

  const resp = await fetch(url, { method, headers, body });
  if (resp.status === 204) return undefined as T;
  const data = await resp.json().catch(() => ({}));
  if (!resp.ok) {
    const message = data?.error?.message || resp.statusText;
    throw new ApiError(message, resp.status, data);
  }
  return data as T;
}

export const api = {
  get: <T = any>(p: string) => request<T>("GET", p),
  post: <T = any>(p: string, body?: any) => request<T>("POST", p, { body }),
  patch: <T = any>(p: string, body?: any) => request<T>("PATCH", p, { body }),
  delete: <T = any>(p: string, body?: any) => request<T>("DELETE", p, { body }),
  upload: <T = any>(p: string, form: FormData) =>
    request<T>("POST", p, { form }),
};
